module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesRomantic@2x.16e5f53.webp";